<div [editableInStoryblok]="_editable">
	<vp-banner [variant]="variant">
		<sb-richtext [content]="content" richTextAlignment="text-center" />
	</vp-banner>
</div>
